import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw"; // 允许解析原始 HTML

import ReactMarkdown from "react-markdown";
import { useMarkdownComponent } from "../hooks/useMarkdownComponent";
import { SourceType } from "./Chat/Source";
import { type ChatJsonRenderContextValue } from "./Chat/jsonRender/ChatJsonRenderContext";
import { type DynamicUiItem } from "./Chat/jsonRender/parseDynamicUiBlocks";

interface MarkdownProps {
  children: string;
  source?: SourceType[];
  showSelect?: boolean;
  isExtension?: boolean;
  h3ClassName?: string;
  className?: string;
  enableNavigation?: boolean;
  currentIndex?: number; // 添加currentIndex参数用于区分唯一性
  linkTarget?: "_self" | "_blank" | "_parent" | "_top"; // a 标签的 target 属性
  onLinkClick?: (
    href: string,
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => void; // 链接点击回调
  dynamicUiItems?: DynamicUiItem[];
  dynamicUiRenderContext?: ChatJsonRenderContextValue;
}

const remarkPlugins = [remarkGfm];

const NonMemoizedMarkdown = ({
  children,
  source,
  showSelect,
  isExtension,
  h3ClassName,
  className,
  enableNavigation = false,
  currentIndex = 0, // 添加currentIndex参数，默认值为0
  linkTarget, // a 标签的 target 属性
  onLinkClick, // 链接点击回调
  dynamicUiItems,
  dynamicUiRenderContext,
}: MarkdownProps) => {
  const components = useMarkdownComponent({
    source,
    showSelect,
    isExtension,
    h3ClassName,
    enableNavigation,
    currentIndex, // 将currentIndex传递给useMarkdownComponent hook
    linkTarget, // 将linkTarget传递给useMarkdownComponent hook
    onLinkClick, // 将onLinkClick传递给useMarkdownComponent hook
    dynamicUiItems,
    dynamicUiRenderContext,
  });

  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={remarkPlugins}
      components={components}
      className={className}
    >
      {children}
    </ReactMarkdown>
  );
};

export const Markdown = NonMemoizedMarkdown;
